export default () => Math.random().toString(16).slice(2);
